import { useMemo } from 'react';
import { useTransition, animated, to } from '@react-spring/web';
import getScaleBaseline from "../../../utils/getScaleBaseline.js";
import { cleanColor, colorHasUrl } from "../../../utils/cleanColorString.js";
/** Memoized useTransition config */
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function useAnimatedGlyphsConfig(_ref) {
  let {
    xScale,
    yScale,
    horizontal
  } = _ref;
  const xScaleBaseline = getScaleBaseline(xScale);
  const yScaleBaseline = getScaleBaseline(yScale);
  return useMemo(() => ({
    unique: true,
    from: _ref2 => {
      let {
        x,
        y,
        color
      } = _ref2;
      return {
        x: horizontal ? xScaleBaseline : x,
        y: horizontal ? y : yScaleBaseline,
        color: cleanColor(color),
        opacity: 0
      };
    },
    leave: _ref3 => {
      let {
        x,
        y,
        color
      } = _ref3;
      return {
        x: horizontal ? xScaleBaseline : x,
        y: horizontal ? y : yScaleBaseline,
        color: cleanColor(color),
        opacity: 0
      };
    },
    enter: _ref4 => {
      let {
        x,
        y,
        color
      } = _ref4;
      return {
        x,
        y,
        color: cleanColor(color),
        opacity: 1
      };
    },
    update: _ref5 => {
      let {
        x,
        y,
        color
      } = _ref5;
      return {
        x,
        y,
        color: cleanColor(color),
        opacity: 1
      };
    },
    keys: glyph => glyph.key
  }), [xScaleBaseline, yScaleBaseline, horizontal]);
}
export default function AnimatedGlyphs(_ref6) {
  let {
    renderGlyph,
    glyphs,
    horizontal,
    xScale,
    yScale,
    onBlur,
    onFocus,
    onPointerMove,
    onPointerOut,
    onPointerUp
  } = _ref6;
  const animatedGlyphs = useTransition(glyphs, {
    ...useAnimatedGlyphsConfig({
      xScale,
      yScale,
      horizontal
    })
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: animatedGlyphs((_ref7, item, _ref8) => {
      let {
        x,
        y,
        color,
        opacity
      } = _ref7;
      let {
        key
      } = _ref8;
      return /*#__PURE__*/_jsx(animated.g, {
        transform: to([x, y], (xVal, yVal) => `translate(${xVal}, ${yVal})`),
        color: color,
        opacity: opacity,
        children: renderGlyph({
          key,
          datum: item.datum,
          index: item.index,
          x: 0,
          y: 0,
          size: item.size,
          // currentColor doesn't work with url-based colors (pattern, gradient)
          // otherwise currentColor allows us to animate the color of the <g /> element
          color: colorHasUrl(item.color) ? item.color : 'currentColor',
          onBlur,
          onFocus,
          onPointerMove,
          onPointerOut,
          onPointerUp
        })
      }, key);
    })
  });
}